import type * as React from 'react';
import { put } from '@Domain/Api';
import type { FacilityPayload } from '@Application/Facilities/Facilities/Actions/facilitiesFetched';
import facilityUpdated, {
	type FacilityUpdatedAction,
} from '@Application/Facilities/Facilities/Actions/facilityUpdated';
import facilityUpdateFailed, {
	type FacilityUpdateFailedAction,
} from '@Application/Facilities/Facilities/Actions/facilityUpdateFailed';
import type UpdateFacility from '@Application/Facilities/Facilities/Commands/UpdateFacility';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityUpdatedAction | FacilityUpdateFailedAction;

export default (command: UpdateFacility) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<FacilityPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/facilities/${command.facilityId}`,
				command.toJSON(),
			);

			const action = facilityUpdated(payload, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
